<template lang="pug">
    .content(v-if="contents && contents.length" ref="container")
        .column.is-offset-1.is-10
            Heading(v-if="heading" :heading="heading.title" :subHeading="heading.sub_title")
        .content-wrap(:class="{ 'column is-offset-1 is-10': imagePosition === 'left-float' }")
            .images(v-if="images && images.length" :class="imagePosition")
                PostImage(
                    v-for="image in images" :key="image.id"
                    :content="image"
                    :count="images.length"
                    :max-width="containerWidth"
                )
            div(v-if="content && content.text" v-html="content.text" :class="{ 'column is-offset-1 is-10': imagePosition === 'top-block' }")
</template>

<script>

import _ from 'lodash'

import Heading from './Heading'
import PostImage from './PostImage'

export default {
    name: 'Post',
    data() {
        return {
            containerWidth: undefined,
        }
    },
    props: {
        section: {
            type: Object,
            required: true,
        },
    },
    components: {
        Heading,
        PostImage,
    },
    computed: {
        contents() {
            return this.section.contents || []
        },
        heading() {
            return this.contents.find(content => content.key === 'heading')
        },
        content() {
            return this.contents.find(content => content.key === 'content')
        },
        images() {
            return this.contents.filter(content => content.key === 'image')
        },
        imagePosition() {
            let position = 'left-float'

            if (this.section.settings && this.section.settings.length) {
                const setting = this.section.settings.find(setting => setting.key === 'image_position')
                if (setting && setting.value !== undefined) position = setting.value
            }

            return position
        },
    },
    mounted() {
        if (this.imagePosition === 'left-float') {
            this.containerWidth = 320
        } else {
            const calculateMaxWidth = () => {
                if (this.$refs.container) {
                    const style = getComputedStyle(this.$refs.container)
                    this.containerWidth = this.$refs.container.clientWidth
                    this.containerWidth -= parseFloat(style.paddingLeft) + parseFloat(style.paddingRight)
                }
            }

            window.addEventListener('resize', _.debounce(calculateMaxWidth, 100))
            calculateMaxWidth()
        }
    }
}
</script>

<style lang="sass" scoped>

    @import "~bulma/sass/utilities/mixins";

    .section.post
        // .images
        //     display: flex
        //     .post-image
        //         margin-right: 10px
        //         /deep/ img
        //             height: auto
        //             max-width: 100%
        //             width: initial
        //         &:last-child
        //             margin-right: 0
        +tablet
            .content-wrap
                // display: flex
                // flex-direction: row
                // flex-flow: row-reverse
                .images.left-float
                    float: left
                    // width: 320px
                    display: block
                    // flex-shrink: 0
                    margin-right: 30px
                    padding-top: 6px
                .images.top-block
                    margin-bottom: 25px
                    display: flex
                    flex-direction: column
                    align-items: center

</style>
